module.exports = __webpack_public_path__ + "media/images/restaurant/logo_master-a571899db50e9e3554b515a481e53ad4.png";